<template>
  <v-container fluid pa-0 ma-0>
    <quote-validation ref="validation"></quote-validation>
    <v-dialog v-model="isDataLoading" modal hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by - Your Quote is being generated
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card>
      <v-container fluid ma-0 pa-0>
        <v-flex xs12>
          <v-card color="light-grey">
            <v-flex xs12>
              <v-title>Quote Actions</v-title>
            </v-flex>
            <v-card-text>
              <v-layout row wrap>
                <v-flex>
                  <v-radio-group
                    v-model="templateOpt"
                    class="mb-2"
                    hide-details
                    @change="previewTemplate"
                    row
                    :disabled="isDataLoading"
                  >
                    <v-radio
                      color="#2f5578"
                      label="Quote Proposal"
                      :value="1"
                    ></v-radio>
                    <v-radio
                      color="#2f5578"
                      label="Quote Summary"
                      :value="2"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-container>
      <v-card-text>
        <div id="HtmlToEmail" npref="summary" class="tall" style="height: auto">
          <v-layout row wrap ma-0 pa-0>
            <v-flex d-flex xs12 fill-height>
              <v-tabs
                v-model="tab"
                centered
                grow
                color="primary"
                slider-color="primary"
                dark
                height="100%"
              >
                <v-tab ripple>
                  Quote
                  <v-subheader>
                    (Download the PDF using the save icon in the pdf viewer)
                  </v-subheader>
                  <v-btn
                    v-if="isAdmin && isQantas"
                    icon
                    color="primary"
                    @click="createPDF('finance')"
                  >
                    <v-icon small>cloud_download</v-icon>
                    Grenke
                  </v-btn>
                </v-tab>

                <v-tab-item :key="1">
                  <v-card flat>
                    <div id="pdf" class="tall">
                      <iframe
                        ref="pdfView"
                        style="width: 100%; height: 100%"
                        frameborder="0"
                        scrolling="no"
                      >
                        <p>
                          It appears your web browser doesn't support iframes.
                        </p>
                      </iframe>
                    </div>
                  </v-card>
                </v-tab-item>
                <v-tab-item :key="2">
                  <v-card flat class="tall">
                    <iframe
                      ref="grenkePdfView"
                      style="width: 100%; height: 100%"
                      frameborder="0"
                      scrolling="no"
                    >
                      <p>
                        It appears your web browser doesn't support iframes.
                      </p>
                    </iframe>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-flex>
          </v-layout>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
const { mapActions: mapSummaryActions } =
  createNamespacedHelpers(`orders/summary`);
import quoteValidation from './quote-validation.vue';

export default {
  components: { quoteValidation },
  name: 'GenerateQuote',
  data: () => ({
    isDataLoading: true,
    tab: 0,
    templateOpt: 1,
  }),
  mounted() {
    let vm = this;
    vm.populateSummary(vm.rows[0].orderID)
      .then(() => {
        vm.$refs.validation
          .validateOrder()
          .then((data) => {
            if (!data) vm.previewTemplate();
          })
          .catch(() => {
            vm.isDataLoading = false;
          });
      })
      .catch(() => {
        vm.isDataLoading = false;
      });
  },
  methods: {
    ...mapSummaryActions(['populateSummary', 'populateQuotePDF']),
    blobToBase64(blob) {
      let vm = this;
      var reader = new FileReader();
      reader.onload = function () {
        var dataUrl = reader.result;
        var base64 = dataUrl.split(',')[1];
        vm.pdfBase64 = base64;
      };
      reader.readAsDataURL(blob);
    },
    previewTemplate() {
      let vm = this;
      vm.$refs.pdfView.src = '';
      vm.isDataLoading = true;

      vm.populateQuotePDF(vm.templateOpt)
        .then((res) => {
          vm.blobToBase64(res);
          vm.$refs.pdfView.src = URL.createObjectURL(res);
          vm.isDataLoading = false;
        })
        .catch(() => {
          vm.isDataLoading = false;
        });
    },
  },
  computed: {
    ...mapOrderState(['rows', 'isAdmin', 'isQantas']),
  },
};
</script>

<style lang="scss" scoped>
.tall {
  height: 80vh;
}
</style>
